module.exports = __webpack_public_path__ + "static/img/invitebg4.a4f8df6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/invitebg4.webp
// module id = ll3d
// module chunks = 0